/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountTypeDialog extends SiteEntityDialog<AccountTypeRow, any> {
        protected getFormKey() { return AccountTypeForm.formKey; }
        protected getIdProperty() { return AccountTypeRow.idProperty; }
        protected getLocalTextPrefix() { return AccountTypeRow.localTextPrefix; }
        protected getNameProperty() { return AccountTypeRow.nameProperty; }
        protected getService() { return AccountTypeService.baseUrl; }

        protected form = new AccountTypeForm(this.idPrefix);

    }
}